export default {
  SITE_RECAPTCHA_KEY: "6Lfjvt0UAAAAACzFHtN16_lnqn-pGLXz2kwT3SUk",
  SPACE_ID: '2g5ul88ox1d6',
  DELIVERY_ACCESS_TOKEN: 'aHoddxjTKa9U8wSN87LXN5WcjliwQ_ZPVxLwB4D9RYU'
}
